module.exports = {
  progressbar: 0,
  step: 0,
  progressFirstTouch: 0,
  calendar: {
    name: "calendar",
    edit: true,
    show: true,
    overview: false,
    step: 1,
  },
  bookables: {
    name: "bookables",
    edit: true,
    show: true,
    overview: false,
    step: 1,
  },
  roomButton: {
    name: "room",
    edit: false,
    show: true,
    overview: false,
    step: 2,
  },
  room_1: {
    name: "room_1",
    edit: false,
    show: false,
    overview: false,
    step: 2,
  },
  "room-n": {
    name: "Room_n",
    edit: false,
    show: false,
    overview: false,
    step: 3,
  },
  additionals: {
    name: "additionals",
    edit: false,
    show: false,
    overview: false,
    step: 4,
  },
  contact: {
    name: "contact",
    edit: false,
    show: false,
    overview: false,
    step: 5,
  },
  overview: {
    name: "overview",
    edit: false,
    show: false,
    overview: false,
    step: 6,
  },
  payment: {
    name: "payment",
    edit: false,
    show: false,
    overview: false,
    step: 7,
  },
};
